import React, { useState, useEffect } from 'react';
import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride';
import { useTheme } from '@mui/material/styles';
import MichiTooltip from './MichiTooltip';
import { useCatAssistant } from '../../contexts/CatAssistantContext';

const MichiTour: React.FC = () => {
    const theme = useTheme();
    const { say } = useCatAssistant();
    const [run, setRun] = useState(false);

    const steps: Step[] = [
        {
            target: 'body',
            title: '¡Bienvenido a Turn.ar! 😺',
            content: 'Soy Michi, tu asistente personal. Estoy aquí para ayudarte a gestionar tu negocio de forma fácil y divertida. ¡Déjame mostrarte cómo funciona!',
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="tour-dashboard"]',
            title: 'Tu Panel de Control',
            content: 'Aquí verás un resumen rápido de tus reservas de hoy, ingresos y estadísticas importantes.',
            placement: 'right',
        },
        {
            target: '[data-tour="tour-inbox"]',
            title: 'Bandeja de Entrada',
            content: 'Gestiona todas las solicitudes de reserva pendientes. ¡No dejes esperando a tus clientes! 😿',
            placement: 'right',
        },
        {
            target: '[data-tour="tour-clients"]',
            title: 'Tus Clientes',
            content: 'Mantén organizada la información de tus clientes fieles. ¡Un cliente feliz siempre vuelve! 😽',
            placement: 'right',
        },
        {
            target: '[data-tour="tour-settings"]',
            title: 'Configuración',
            content: 'Personaliza tu perfil, horarios y preferencias del sistema aquí.',
            placement: 'right',
        },
        {
            target: '[data-tour="tour-notifications"]',
            title: 'Notificaciones',
            content: 'Te avisaré aquí cuando tengas nuevas reservas o actualizaciones importantes.',
            placement: 'bottom',
        },
        {
            target: 'body',
            title: '¡Eso es todo por ahora!',
            content: 'Si necesitas ayuda, siempre estaré por aquí. ¡Que tengas un día muy productivo! 😸',
            placement: 'center',
        }
    ];

    useEffect(() => {
        const tourCompleted = localStorage.getItem('michi_tour_completed');
        if (!tourCompleted) {
            // Small delay to ensure everything is rendered
            const timer = setTimeout(() => {
                setRun(true);
                say('¡Hola! Soy Michi. ¿Me dejas enseñarte el lugar? 😺', 'greeting');
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [say]);

    const handleJoyrideCallback = (data: CallBackProps) => {
        const { status } = data;
        const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            setRun(false);
            localStorage.setItem('michi_tour_completed', 'true');
            say('¡Genial! Ahora ya eres un experto. ¡A trabajar! 💪', 'success');
        }
    };

    return (
        <Joyride
            steps={steps}
            run={run}
            continuous
            showProgress
            showSkipButton
            tooltipComponent={MichiTooltip}
            callback={handleJoyrideCallback}
            styles={{
                options: {
                    zIndex: 10000,
                    primaryColor: theme.palette.primary.main,
                },
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    mixBlendMode: 'hard-light'
                }
            }}
            floaterProps={{
                // disableAnimation: true, // Not supported in v3 types yet
            }}
        />
    );
};

export default MichiTour;
